import React from "react";
import { DATE_RANGE_TYPE } from "../../home-dashboard-v2/helpers/date-helper";
import FilterInventory from "../../home-dashboard-v2/components/filter-inventory";
import FilterDateRange from "../../home-dashboard-v2/components/filter-date-range";
import FilterCurrencySelector from "../../home-dashboard-v2/components/filter-currency-selector";
import FilterRequestType from './filter-request-type';

class FilterHeader extends React.Component {
  constructor(props) {
    super(props);

    const dateRangeType = DATE_RANGE_TYPE.THIS_MONTH;
    const { startDate, endDate } = props;

    this.state = {
      dateRangeType,
      startDate,
      endDate,
    };
  }

  render() {
    const {
      isReseller,
      publishers,
      selectedPubId,
      networks,
      selectedNetworkId,
      handleInventoryFilterChanged,
      handleDateRangeFilterChanged,
      yieldSets,
      selectedYieldSetIds,
      selectedCurrency,
      currencies,
      handleCurrencyChanged,
      startDate,
      endDate,
      requestTypes,
      selectedRequestType,
      handleRequestTypeFilterChanged,
    } = this.props;

    return (
      <React.Fragment>
        <div className="bg-light shadow-sm">
          <div className="d-flex justify-content-between" style={styles.header}>
            <div className="d-flex">
              <FilterInventory
                isReseller={isReseller}
                publishers={publishers}
                selectedPubId={selectedPubId}
                networks={networks}
                yieldSets={yieldSets}
                selectedNetworkId={selectedNetworkId}
                selectedYieldSetIds={selectedYieldSetIds}
                handleInventoryFilterChanged={handleInventoryFilterChanged}
              ></FilterInventory>

              <div className="ml-2">
                <FilterDateRange
                  startDate={startDate}
                  endDate={endDate}
                  handleDateRangeFilterChanged={handleDateRangeFilterChanged}
                ></FilterDateRange>
              </div>

              <div className="ml-2">
                <FilterRequestType
                  requestTypes={requestTypes}
                  selectedRequestType={selectedRequestType}
                  handleRequestTypeFilterChanged={handleRequestTypeFilterChanged}
                ></FilterRequestType>
              </div>
            </div>

            <div>
              <FilterCurrencySelector
                currencies={currencies}
                selectedCurrency={selectedCurrency}
                handleCurrencyChanged={handleCurrencyChanged}
              ></FilterCurrencySelector>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const styles = {
  header: {
    padding: "8px 24px",
    maxWidth: "1280px",
    margin: "auto",
  },
  filterBtn: {
    border: "1px solid lightgray",
  },
  currencySelector: {
    width: "120px",
  },
};

export default FilterHeader;
